/* eslint-disable no-unused-vars */
import { ImagesMobile } from '@/assets/images';
import { memo, useCallback, useMemo } from 'react';

import { Pagination, PaginationProps } from 'antd';
import { getPagePagination } from 'utils';

interface IPagination extends PaginationProps {
	current: number;
	onChange: (current: number, pageSize?: number) => void;
	total: number;
	totalLocal?: number;
	hideOnSinglePage: boolean;
	className?: string;
	showSizeChanger?: boolean;
	pageSize?: number;
}

const CPagination = ({ pageSize, ...props }: IPagination) => {
	const handleChangePage = useCallback(
		(page: number) => {
			if (page === props.current) return;
			props.onChange(page, pageSize);
		},
		[props, pageSize]
	);

	const itemRender: PaginationProps['itemRender'] = (
		_,
		type,
		originalElement
	) => {
		if (type === 'prev') {
			return (
				<img
					src={ImagesMobile.iconPaginationPrev}
					className="w-[24px] md:w-[32px] h-[24px] md:h-[32px]"
				/>
			);
		}
		if (type === 'next') {
			return (
				<img
					src={ImagesMobile.iconPaginationNext}
					className="w-[24px] md:w-[32px] h-[24px] md:h-[32px]"
				/>
			);
		}
		return originalElement;
	};

	const lastPage = useMemo(() => {
		return getPagePagination(props.totalLocal ?? props.total, pageSize);
	}, [props.totalLocal, props.total, pageSize]);

	return (
		<div className="flex items-center justify-between">
			<img
				src={ImagesMobile.iconPaginationStart}
				className={`w-[24px] md:w-[32px] h-[24px] md:h-[32px] ${props?.current === 1 ? 'opacity-50' : ''}`}
				onClick={() => handleChangePage(1)}
			/>
			<Pagination
				current={props?.current}
				onChange={props?.onChange}
				total={props?.total}
				showSizeChanger={false}
				hideOnSinglePage={props.hideOnSinglePage}
				className={props.className}
				responsive={true}
				showLessItems
				pageSize={pageSize}
				rootClassName="flex items-center justify-center [&>li]:!w-[24px] md:w-[32px] [&>li]:!h-[24px] [&>li]:md:!h-[32px] md:w-[32px] [&>.ant-pagination-item]:!mx-[1.111vw] [&>.ant-pagination-item-active]:!bg-blue2 [&>.ant-pagination-item>a]:text-font2 [&>.ant-pagination-item-active>a]:!text-white  w-full"
				itemRender={itemRender}
			/>
			<img
				src={ImagesMobile.iconPaginationEnd}
				className={`w-[24px] md:w-[32px] h-[24px] md:h-[32px] ${props?.current === lastPage ? 'opacity-50' : ''}`}
				onClick={() => handleChangePage(lastPage)}
			/>
		</div>
	);
};

export default memo(CPagination);
